module.exports = __webpack_public_path__ + "img/mask.f64bb768.png";